import styled from "styled-components";

import { TextField } from "@material-ui/core";

export const TextFieldCustom = styled(TextField)`
  input {
    ${(props) => (props.$textAlignCenter ? "text-align: center;" : "")}
  }

  &.UpdatedValue {
    label {
      color: white;
    }

    input {
      padding-right: 12px;
      overflow: hidden;
      background: ${(props) => props.theme.palette.green};
      border-bottom: 3px solid ${(props) => props.theme.palette.primary};
      border-radius: 5px;
      color: white;
      ${(props) => (props.$textAlignRight ? "text-align: right;" : "")}
      ${(props) => (props.$textAlignCenter ? "text-align: center;" : "")}

      &::placeholder {
        color: white;
        padding-left: 10px;
        opacity: 1;
      }
    }

    .MuiInputBase-root {
      font-size: 22px;
      padding-right: 0;
      padding-left: 0;

      &.Mui-error {
        input {
          background: ${(props) => props.theme.palette.darkred};
        }
      }
    }
  }

  &.Highlighted {
    label {
      color: ${(props) => props.theme.palette.white};
    }

    input {
      padding-right: 12px;
      font-size: 32px;
      color: white;
      border-bottom: 3px solid ${(props) => props.theme.palette.primary};
      border-radius: 5px;
      background: ${(props) => props.theme.palette.blue};
      overflow: hidden;
      ${(props) => (props.$textAlignRight ? "text-align: right" : "")}
      ${(props) => (props.$textAlignCenter ? "text-align: center;" : "")}
    }

    .MuiInputBase-root {
      font-size: 22px;
      padding-right: 0;
      padding-left: 0;
    }
  }

  &.DiscountItens {
    label {
      color: ${(props) => props.theme.palette.darkgrey};
    }

    input {
      padding-right: 12px;
      font-size: 32px;
      color: ${(props) => props.theme.palette.lightgrey};
      border-bottom: 3px solid ${(props) => props.theme.palette.orange};
      border-radius: 5px;
      background: ${(props) => props.theme.palette.primary};
      overflow: hidden;
      ${(props) => (props.$textAlignRight ? "text-align: right" : "")}
      ${(props) => (props.$textAlignCenter ? "text-align: center;" : "")}
    }

    .MuiInputBase-root {
      font-size: 22px;
      padding-right: 0;
      padding-left: 0;
    }
  }
`;
